import api from 'api'
//import drawdown from './reducer'
import {
  ADVISOR_DRAWDOWN_NOTE_RECEIVED,
  ADVISOR_DRAWDOWN_RECEIVED,
  ADVISOR_DRAWDOWN_SETTINGS_RECEIVED,
  ADVISOR_DRAWDOWN_UNLOADED
} from './types'

// redux actions
export const advisorNoteReceived = note => ({
  type: ADVISOR_DRAWDOWN_NOTE_RECEIVED,
  note
})

export const advisorDrawDownReceived = drawdown => ({
  type: ADVISOR_DRAWDOWN_RECEIVED,
  data: drawdown
})

export const advisorDrawDownSettingsReceived = settings => ({
  type: ADVISOR_DRAWDOWN_SETTINGS_RECEIVED,
  settings
})

export const advisorDrawDownUnload = () => ({
  type: ADVISOR_DRAWDOWN_UNLOADED
})

export const unloadAdvisorDrawDown = () => dispatch => {
  dispatch(advisorDrawDownUnload())
}

export const getDrawDown = (id, year) => dispatch => 
  api.bmc.advisor.drawDown(id, year).then(res => dispatch(advisorDrawDownReceived(res)))

export const updateYear = data => dispatch =>
  api.bmc.advisor.updateYear(data).then(res=> {
    dispatch(advisorDrawDownReceived(res))
    return res
  })

export const updateNote = data => dispatch =>
  api.bmc.advisor.updateNote(data).then(res=> {
    dispatch(advisorNoteReceived(res))
    return res
  })

export const updateSettings = data => dispatch =>
  api.bmc.advisor.updateSettings(data).then(res=> { 
      dispatch(advisorDrawDownSettingsReceived(res))     
      return res
  })

export const getSettings = (id) => dispatch => 
  api.bmc.advisor.getSettings(id).then(res => dispatch(advisorDrawDownSettingsReceived(res)))